/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useEffect, useRef, useState } from "react";
import { Input, Spin, Table, Col, Tooltip, message, Button } from "antd";
import Moment from "react-moment";
import { useLocation, useNavigate } from "react-router-dom";

// import { getManifestTableData } from "../../../../actionsMethods/manifestMethods";
import Smcs_Loader from "../../../../assests/images/loader-new.gif";

import TableContainer from "../../../../components/TableContainer";
import print_icon from "../../../../assests/images/printIcon.svg";
import search_icon from "../../../../assests/images/search-icon.svg";
import "./style.scss";
import { serialNum } from "../../../../utils";
import API from "../../../../api";
import urls from "../../../../api/urls";
import useCustomNavigate from "../../../../components/customNavigationHook";
import hardware_print_icon from "../../../../assests/images/hardwarePrinter.png";
import DeleteIcon from "../../../../assests/images/deleteIcon.svg";
// import DeleteIcon from "../../../../assests/images/onbording/delete-box.svg";

const { GET_ALL_CP_MANIFEST_LIST, DELETE_SINGLE_MANIFEST } = urls;

const ViewManifest = () => {
  // const dispatch = useDispatch();
  const navigate = useCustomNavigate();

  const [loading, setLoading] = useState(false);
  const [allFilters, setAllFilters] = useState({
    pageNo: null,
    pageSize: null,
    search: null,
    status: null,
  });

  const [inputSearchValue, setInputSearchValue] = useState("");
  const [pageSize, setPageSize] = useState(20);
  const [pageNum, setPageNum] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const history = useLocation();
  const backHistory = history?.state?.manifest;

  useEffect(() => {
    const { state } = history || {};

    if (backHistory) {
      setAllFilters({ ...state });
      getAllManifest(
        state?.pageNo,
        state?.pageSize,
        state?.search,
        state?.status
      );
    }
  }, [history]);

  function MyComponent(dateToFormat) {
    const toUpperCaseFilter = (d) => {
      return d.slice(0, 10);
    };
    return (
      <Moment filter={toUpperCaseFilter} format="DD/MM/YYYY">
        {dateToFormat}
      </Moment>
    );
  }

  const navigatePage = (record) => {
    localStorage.setItem(
      "manifestedId",
      JSON.stringify(record?.manifestId) || null
    );
    localStorage.setItem("manifestFor", record?.travelBy || null);
    if (
      record?.status === "LOCKED" ||
      record?.status === "HUB-IN-SCANNED" ||
      record?.status === "OUT-SCANNED"
    ) {
      navigate(`/print/${record?.manifestId}`);
    } else if (record?.status === "UNLOCKED") {
      navigate(`/truck/${record?.manifestId}`);
    } else {
      if (record?.travelBy === "surface") {
        navigate("/scan", { state: { ...allFilters, manifest: true } });
        // navigate("/child-scan", { state: "false" });
        // navigate("/cp-packeting", { state: "false" });
        // navigate("/viewBooking-packet", { state: "false" });
      } else {
        navigate("/scan", { state: { ...allFilters, manifest: true } });

        // navigate("/viewBooking-packet", { state: "false" });
        // navigate("/child-scan", { state: "false" });
        // navigate("/cp-packeting", { state: "false" });
      }
    }
  };
  useEffect(() => {
    if (!backHistory) {
      getAllManifest(pageNum, pageSize);
      setAllFilters({
        pageNo: pageNum,
        pageSize: pageSize,
        search: inputSearchValue,
        status: null,
      });
    }
  }, [backHistory]);

  // 0&bookingType=account&shipmentType=dox&shipService=standard&shipmentMode=air&shipmentstatus=MANIFESTED&awbNumber=2024'

  const statusList = [
    {
      value: "UNLOCKED",
      text: "UNLOCKED",
    },
    {
      value: "INITIATED",
      text: "INITIATED",
    },
    {
      value: "LOCKED",
      text: "LOCKED",
    },
    {
      value: "OUT-SCANNED",
      text: "OUT-SCANNED",
    },
  ];

  const getAllManifest = async (pageNo, pageSize, search, status) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    setLoading(true);

    let url = `${GET_ALL_CP_MANIFEST_LIST}?pageNum=${pageNo}&pageSize=${pageSize}`;

    if (search) {
      url += `&manifestId=${search}`;
    }

    if (status) {
      url += `&status=${status.toUpperCase()}`;
    }

    let response = await API.Api(url).getWithUserNPremiseHeader();
    if (response?.status) {
      setLoading(false);
      let res = response?.response?.data;
      setTableData(res);
      setAllFilters({
        pageNo: pageNum,
        pageSize: pageSize,
        search: inputSearchValue,
        status: status?.toUpperCase(),
      });

      // setData(result);
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  function capitalizeFirstLetter(string) {
    return string?.charAt(0)?.toUpperCase() + string?.slice(1);
  }

  const deleteManifest = async (params) => {
    setLoading(true);
    let url = `${DELETE_SINGLE_MANIFEST + "/" + params}`;

    let response = await API.Api(url).deleteIdHeader();
    if (response?.status) {
      setLoading(false);
      getAllManifest(pageNum, pageSize, null, allFilters?.status || null);
      message.success(response?.response?.data?.message);
      // setTotalLoad(response?.response?.data);
    } else {
      setLoading(false);

      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  const currentEnv = process.env.REACT_APP_ENV;

  const columns = [
    {
      title: "SI",
      dataIndex: "manifestId",
      key: "manifestId",
      width: 50,
      ellipsis: false,
      render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
    },
    {
      title: "Manifest ID",
      dataIndex: "manifestId",
      width: 120,
      ellipsis: false,
      sorter: {
        compare: (a, b) => a?.manifestId - b?.manifestId,
      },
      key: "manifestId",
      render: (_, record) => (
        <a onClick={() => navigatePage(record)}>{record.manifestId}</a>
      ),
    },
    {
      title: "Date",
      width: 90,
      ellipsis: false,
      dataIndex: "createDate",
      key: "createDate",
      render: (text) => MyComponent(text),
    },
    {
      title: (
        <>
          <span>
            Mode of <br /> manifest
          </span>
        </>
      ),
      ellipsis: false,
      width: 70,
      dataIndex: "travelBy",
      key: "travelBy",
      render: (text) => capitalizeFirstLetter(text),
    },
    {
      title: (
        <>
          <span>
            No of <br /> shipment(s)
          </span>
        </>
      ),
      dataIndex: "shipmentNum",
      key: "shipmentNum",
      width: 75,
      sorter: {
        compare: (a, b) => a?.shipmentNum - b?.shipmentNum,
      },
      ellipsis: false,
    },
    // {
    //   title: "No of packet(s)",
    //   dataIndex: "packetNum",
    //   key: "packetNum",
    //   width: 100,
    //   ellipsis: false,
    // },

    {
      title: "Total weight(Kg)",
      ellipsis: false,
      dataIndex: "totalweight",
      // sorter: {
      //   compare: (a, b) => a?.totalweight - b?.totalweight,
      // },
      width: 50,
      key: "totalweight",
      render: (text) => (text === null ? 0 : text),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 60,
      ellipsis: true,

      filters: statusList,

      filteredValue: allFilters?.status ? [allFilters.status] : null,

      filterMultiple: false,
      render: (_, record) => (
        <span
          style={{
            color:
              record.status === "LOCKED"
                ? "#46C196"
                : record.status === "UNLOCKED"
                ? "#85AFE1"
                : "orange",
          }}
        >
          {record.status}
        </span>
      ),
    },

    {
      title: "Action",
      ellipsis: false,
      dataIndex: "",
      // sorter: {
      //   compare: (a, b) => a?.totalweight - b?.totalweight,
      // },
      width: 80,

      key: "",
      render: (a, record) => {
        let check =
          record?.status === "LOCKED" ||
          record?.status === "HUB-IN-SCANNED" ||
          record?.status === "OUT-SCANNED";

        const status = record.status === "UNLOCKED";
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              columnGap: "20px",
              cursor: "pointer",
              alignItems: "center",
              marginBottom: 0,
            }}
          >
            {check ? (
              <>
                <Tooltip title={"Print manifest"}>
                  <a onClick={() => navigatePage(record)}>
                    <img
                      src={print_icon}
                      style={{ width: "22px", height: "20px" }}
                    />
                  </a>
                </Tooltip>
              </>
            ) : (
              <Tooltip title={"Print manifest"}>
                <img
                  src={print_icon}
                  style={{
                    width: "22px",
                    height: "20px",
                    cursor: "not-allowed",
                  }}
                />
              </Tooltip>
            )}
            <Tooltip title={"Print E-way "} placement="left">
              <p
                className="vbooking-icons"
                style={{
                  cursor: "pointer",
                }}
              >
                <img
                  src={hardware_print_icon}
                  style={{ width: "12px", height: "12px" }}
                  onClick={() =>
                    navigate("/print-eway-bill", {
                      state: {
                        state: record?.manifestId,
                        key: "VIEW_MANIFEST",
                        slug: "/viewBooking",
                      },
                    })
                  }
                />
              </p>
            </Tooltip>

            {status ? (
              <Tooltip title={"Delete manifest"} placement="right">
                <p
                  className="vbooking-icons"
                  style={{ marginTop: "-5px" }}
                  onClick={(e) => {
                    deleteManifest(record?.manifestId);
                    // printerCallBack(record?.awbNumber);
                  }}
                >
                  <img
                    src={DeleteIcon}
                    style={{ width: "18px", height: "22px" }}
                  />
                </p>
              </Tooltip>
            ) : (
              <Tooltip title={null} placement="right">
                <p className="vbooking-icons" style={{ marginTop: "-5px" }}>
                  <img
                    src={DeleteIcon}
                    style={{
                      width: "18px",
                      height: "22px",
                      cursor: "not-allowed",
                    }}
                  />
                </p>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const debounceTimeout = useRef(null);

  function handlePageChange(pagination, filters) {
    window.scrollTo(0, 0);

    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    setCurrentPage(pagination.current);
    // setPageSize(pagesize);
    if (filters?.status) {
      getAllManifest(
        pagination.current - 1,
        pagination?.pageSize,
        null,
        filters?.status[0] || null
      );
    } else {
      getAllManifest(pagination.current - 1, pagination?.pageSize);
    }

    setInputSearchValue("");
  }
  // function handleMainPageChange(_, filters) {
  //   getAllManifest(pageNum, pageSize, filters?.status[0]);
  //   setInputSearchValue("");
  // }

  const onSearch = (e) => {
    const currValue = e.target.value;

    if (currValue && isNaN(currValue)) {
      return;
    }
    if (currValue) setPageNum(0);
    setPageSize(pageSize);
    setInputSearchValue(currValue);
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(async () => {
      getAllManifest(0, 20, currValue);
    }, 900);
  };

  const handleGenerateManifest = () => {
    navigate("/scan", { state: { ...allFilters, manifest: true } });
  };

  return (
    <Spin
      spinning={loading}
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <div className="view-manifest-container">
        <div className="d-flex flex-end">
          <Col className="search-box">
            <Input
              placeholder="Search by manifest Id"
              bordered
              onChange={onSearch}
              //maxLength={14}
              // type="number"
              style={{ borderRadius: "5px", height: "30px", width: "100%" }}
              suffix={<img src={search_icon} />}
              value={inputSearchValue}
            />
          </Col>

          <Col className="generate-manifest">
            <Button
              type="primary"
              onClick={handleGenerateManifest}
              className="addPacketBtn ml-1 "
              // disabled={!manifestFor}
            >
              CREATE MANIFEST
            </Button>
          </Col>
        </div>
        <div className="manifest-table-container mt-1">
          <TableContainer
            className="table-head-sticky"
            columns={columns}
            dataSource={tableData?.manifestList}
            pagination={{
              pageSize: pageSize,
              current: currentPage,
              total: tableData?.totalElements,
              itemRender: itemRender,

              // showSizeChanger: true,
              // onChange: handlePageChange,
            }}
            onChange={handlePageChange}
          />
        </div>
      </div>
    </Spin>
  );
};

export default React.memo(ViewManifest);
